import { FileInfo } from './courseData';

export function validateCurriculum(files: FileInfo[]) {
  return files.length > 0;
}
